<style lang="less">
@import './less/login.less';
@import "../operations/less/showmodel.less";
@import "../../styles/public/public.less";

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px rgb(26, 76, 115) inset;
    border: 1px solid rgb(23, 112, 142) !important;
    -webkit-text-fill-color: #0ae3e1;
}
#register_comp{
    .ivu-upload-drag{
        border: 1px dashed rgb(12, 218, 217);
}
}

</style>
<template>
<div class="unitlogin" style="background-image: url(./static/images/1.png);background-size: 100% 100%;">
    <div style="color:rgb(12, 218, 217);cursor:pointer;" @click="changePage(1)">
        <img :src="url.url_3" style="width:9px;">
        <span>返回</span>
    </div>
    <div v-for="item in editInfo" :key="item.name" class="display_row_ac" style="color:rgb(12, 218, 217);height:37px;">
        <div class=" display_row_jc_ac dispaly_flex00" style="width:90px;">
            <span>{{item.name}}:</span>
        </div>
        <div class=" display_row_ac dispaly_flex11 " style="width:300px;">
            <Input v-model="item.value" :placeholder="'请输入'+item.name" style="width: 100%" />
        </div>
    </div>
    <div style="height: auto;color:rgb(12, 218, 217);width:100%;" class="showmodel_1hz display_row_ac media_w_showmodel1hz">
            <div class=" display_row_jc_ac dispaly_flex00" style="width:90px;">
                <span>营业执照照片:</span>
            </div>
            <div style="margin-bottom: 10px;" class="showmodel_1hz_2 display_row_ac dispaly_flex11 ">
                <div id="register_comp" class="piccolumn1" style="margin-top:10px;">
                    <div v-for="(item,index) in photosurl" :key="item.ID" style="position: relative;width:15vh;height:12vh;margin-right:10px;">
                        <div style="position: absolute; width:100%;text-align:right;z-index:2;float:right;top:0px;right:0px;" @click="deletepic(index)">
                            <img src="../../../static/images/icon_delete.png" style="cursor:pointer" />
                        </div>
                        <div style="" v-viewer>
                            <img :src="item.path" style="width:15vh;height:12.5vh;" />
                        </div>
                    </div>
                    <Upload ref="upload"  :show-upload-list="false" v-show='!forbidimg' :before-upload="handleBeforeUpload" :on-success="uplloadSucess" :format="['jpg','png']" :action="uploadUrl" :data="uploadData" type="drag" style="width:114px;">
                        <div style="padding: 0.5vh;height:12vh;">
                            <Icon type="ios-cloud-upload-outline" size="42" />
                            <p style="height: 46px;line-height: 16px;">图片拖至此处或者单击选择图片</p>
                        </div>
                    </Upload>                  
                </div>
            </div>
        </div>
    <div style="" class="display_row_jc_ac ">
        <input type="button" value="保  存" class="login_btn2" @click="checkCreditCode()" />
    </div>
</div>
</template>

<script>
import bus from "../../app/event";
import Cookies from "js-cookie";
import companyregistered from "./companyregistered.vue";
export default {
    components: {
        companyregistered
    },
    data() {
        return {
            url: {
                url_2: "./static/images/1.png",
                url_3: "./static/images/返回.png",
            },
            names: {
                names_1: "版权所有：南京市测绘勘察研究院股份有限公司",
                names_2: "技术支持：南京市测绘勘察研究院股份有限公司",
            },
            editInfo: [{
                    name: '单位名称',
                    value: '',
                    type: 'mc',
                },
                {
                    name: '社会信用代码',
                    value: '',
                    type: 'creditcode',
                },
                {
                    name: '单位地址',
                    value: '',
                    type: 'dwdz',
                },
                {
                    name: '邮编',
                    value: '',
                    type: 'yb',
                },
                {
                    name: '单位负责人',
                    value: '',
                    type: 'fzr',
                },
                {
                    name: '联系电话',
                    value: '',
                    type: 'dh',
                },
                {
                    name: '单位性质',
                    value: '',
                    type: 'dwxz',
                }
            ],
            type: 1,
            companyType: [{
                    value: 1,
                    label: '计划类'
                },
                {
                    value: 2,
                    label: '指导类'
                }
            ],
            pickeystr: "",
            photosurl: [], //存储照片
            photoindex: 0,
            photoinfo: "图片拖至此处或者单击选择图片",
            file: [],
            uploadFile: [],
            uploadData: {},
            uploadUrl: appurl.ip + "/ylkjservice/services/hander.ashx?action=uplicenseFile",
            headImg: {},
            url: '',
            forbidimg: false,
            checkcode: '', //用来比对的社会信用代码
        };
    },
    watch: {},
    methods: {
        saveInfo: function () {
            let phonenum = this.editInfo[4].value;
            // if (!(/^1[3|4|5|7|8][0-9]\d{8}$|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/.test(phonenum))) {
            //     alert("不是完整的11位手机号或者正确的手机号前七位");
            //     return
            // }
            
            if (this.editInfo[0].value.length == 0) {
                this.$Message.warning('单位名称不能为空');
                return
            }
            if (this.editInfo[1].value.length == 0) {
                this.$Message.warning('社会信用代码不能为空');
                return
            }
            if(this.photosurl.length==0){
                this.$Message.warning('附件不能为空');
                return
            }
            this.$http.post(
                    appurl.ip + "/ylkjservice/services/hander.ashx?action=saveorg", {
                        DWMC: this.editInfo[0].value,
                        DWADDRESS: this.editInfo[2].value,
                        ZIPCODE: this.editInfo[3].value,
                        FZR: this.editInfo[4].value,
                        PHONENUM: this.editInfo[5].value,
                        KIND: this.editInfo[6].value,
                        CREDITCODE: this.editInfo[1].value,
                        CREDITIMG:this.url
                    }
                )
                .then(res => {
                    if (res.status == 200 && res.data.success == 'true') {
                        bus.$emit('showunit_login', 1);
                        bus.$emit('refreshreg');
                        this.photosurl=[];
                        this.editInfo.forEach(el => {
                            el.value='';
                        });
                        this.$Message.success('新建单位成功');
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "访问失败！",
                        duration: 3
                    });
                })
        },
        //检查社会信用代码是否重复
        checkCreditCode: function (code) {
            if (this.flag) {
                let newcode = this.editInfo[1].value;
                //如果没修改信用代码则直接跳过重复检查
                if (newcode === this.checkcode) {
                    this.saveInfo();
                    return
                }
            }
            let data = {
                FILED: 'creditcode',
                TABLENAME: 'SYS_ORGANIZATION',
                SQLWHERE: `creditcode=${this.editInfo[1].value}`
            }
            this.$http.post(
                    appurl.ip + "/ylkjservice/services/hander.ashx?action=generalsql", data
                )
                .then(res => {
                    if (res.status == 200) {
                        if (res.data.length == 0) {
                            this.saveInfo();
                        } else {
                            this.$Message.warning('重复的社会信用代码');
                        }
                    } else {
                        this.$Message.warning('校验失败')
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "访问失败！",
                        duration: 3
                    });
                })
        },
        //删除照片
        deletepic: function (index) {
            this.photosurl.splice(index, 1);
            this.file.splice(index, 1);
            this.uploadFile.splice(index, 1);
            this.forbidimg = false;
            this.url = '';
        },
        handleBeforeUpload(file) {

            let src;
            src = URL.createObjectURL(file);
            let keyID = this.guid(); //Math.random().toString().substr(2);
            let obj = {
                ID: keyID,
                path: src
            };
            this.photosurl.push(obj);
            this.forbidimg = true; //只能上传一张
            this.uploadData = {
                keyID: keyID
            };

            let promise = new Promise(resolve => {
                this.$nextTick(function () {
                    resolve(true);
                });
            });

            file["keyID"] = keyID;
            this.file.push(file);
            this.uploadFile.push(file);
            //URL.revokeObjectURL(src);
            this.photoinfo = "已选择【 " + this.uploadFile.length + " 】张图片";
            return promise;
        },
        //文件上传成功
        uplloadSucess(res, file) {
            this.url = res.url;
            this.photoindex++;
            if (this.photoindex >= this.uploadFile.length) {
                var pickey = "";
                this.pickeystr = "";
                for (let i = 0; i < this.uploadFile.length; i++) {
                    let item = this.file[i];
                    if (pickey != item.keyID) {
                        pickey = item.keyID;
                        if (this.pickeystr == "") this.pickeystr = pickey;
                        else this.pickeystr = this.pickeystr + "," + pickey;
                    }
                }
            }
        },
        //创建GUID
        guid: function () {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
                c
            ) {
                var r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },
        changePage: function (index) {
            bus.$emit('showunit_login', 1);
        },
    },
    mounted() {
        this.forbidimg=false;
    },
    beforeDestroy() {},
    destoryed: function () {},
};
</script>



// WEBPACK FOOTER //
// companyregistered.vue?89726e6a